import type { GetUserGroupsWithApproversResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetUserGroupsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetUserGroupsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetUserGroups = createQueryHook<
  Record<string, never>,
  GetUserGroupsWithApproversResponseRow[],
  GetUserGroupsQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.userGroup.userGroupsWithApprovers.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ user_group: data }),
  graphqlDocument: GetUserGroupsDocument,
});
